import createLeadFieldSelect from "./createLeadFieldSelect";

export default createLeadFieldSelect("/leads/all_closest_offices", {
  displayName: "ClosestOfficeSelect",
  defaultPlaceholder: "Select Closest Office",
});
